import { useContext } from 'react';
import { AppContext } from '../../context/appContext';

/**
 * @typedef {import('@nike/web-shell-types').LocaleData & { countryOrMarketplaceId: string }} Locale
 */

/**
 * returns locale data
 * @returns {Locale|{}} from getLocale stored in NAV_INITIAL_DATA
 * and distributed through the app context
 */
const useLocale = () => {
  const [data] = useContext(AppContext);
  return data?.locale || {};
};

export default useLocale;
